import React, { useState, useEffect } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavCommunications,
} from "../../../../components/AdminComponents/MenuItems";
import { Avatar, Pagination, Spin, Switch, Table, Tag } from "antd";
import {
  capitalizeWords,
  getFullApplicationName,
  ModuleColor,
  // RecipientsColor,
  remainingViewportHeight,
  UserTypeColor,
} from "../../../../components/icons/ApplicationColor";
import { useNavigate } from "react-router-dom";
import EditableImage from "../../../../components/icons/EditIcon";
import { useSelector } from "react-redux";
import { getUpdateStatus } from "../../../../components/AdminComponents/ViewUpdateIndex";
import Axios from "../../../../api/Axios";
import { UserOutlined } from "@ant-design/icons";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
const Triggers = () => {
  // eslint-disable-next-line no-unused-vars
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 3, 0);
  const history = useNavigate();

  const handleRowClick = (record) => {
    history(
      `/ca-admin/organization/communications/triggers/edit-trigger/${record}`
    );
  };

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [itemsLength, setItemsLength] = useState();
  // eslint-disable-next-line no-unused-vars
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    active: true,
    url: `/mailtriggerlist/${userInfo?.data?.organization?.id}/`,
    search: "",
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, url, search, active } = filterData;
  const LoadContacts = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        //console.log(res.data.results);
        setItemsLength(res.data.count);
        setData(res.data.results);
        setLoading(false);

        //console.log(data);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setLoading(false);
        }
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    LoadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const columns = [
    {
      title: capitalizeWords("NAME"),
      dataIndex: "name",
      key: "name",
      width: 250,
    },
    {
      title: capitalizeWords("TEMPLATE"),
      dataIndex: "template",
      key: "template",
      width: 250,
      render: (text) => (
        <>
          <span>{text?.title}</span>
        </>
      ),
    },
    {
      title: capitalizeWords("ABBREVIATION"),
      dataIndex: "abbreviation",
      key: "abbreviation",
      width: 150,
    },
    {
      title: capitalizeWords("ACTION TIME"),
      dataIndex: "action_time",
      key: "action_time",
      width: 150,
    },
    {
      title: capitalizeWords("MODULE ACCESS"),
      dataIndex: "template",
      key: "template",
      width: 200,
      render: (text) => (
        <>
          <Tag
            color={ModuleColor(getFullApplicationName(text?.application))}
            title={text?.application}
            style={{ fontWeight: "500", margin: "3px" }}
          >
            {getFullApplicationName(text?.application).toUpperCase()}
          </Tag>
        </>
      ),
    },
    {
      title: capitalizeWords("USER ACCESS"),
      dataIndex: "template",
      key: "template",
      width: 200,
      render: (text) => (
        <>
          {text?.user_type?.map((type, index) => (
            <Tag
              color={UserTypeColor(type)}
              key={index}
              title={type}
              style={{ fontWeight: "500", margin: "3px" }}
            >
              {type.toUpperCase()}
            </Tag>
          ))}
        </>
      ),
    },

    {
      title: capitalizeWords("CREATED BY"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt={record?.created_by?.full_name}
            src={record?.created_by?.profile_pic || null}
            icon={!record?.created_by?.profile_pic && <UserOutlined />}
            size="small"
          />
          <span style={{ marginLeft: 8 }}>
            {record?.created_by?.full_name || "Unknown"}
          </span>
        </div>
      ),
    },

    ...(updateAuth
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            dataIndex: "actions",
            key: "actions",
            fixed: "right",
            align: "center",
            width: 100,
            onCell: (record) => {
              return {
                onClick: (event) => {
                  event.stopPropagation();
                },
              };
            },
            render: (text, record) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <EditableImage
                  handleRowClick={handleRowClick}
                  recordId={record.id}
                />
              </div>
            ),
          },
        ]
      : []),
  ];

  const handleSearchChange = () => {};
  return (
    <CaSideNav props={CaAdminMenu}>
      <SecondaryNav2 menuItems={SecondaryNavCommunications} />
      <CommonTopDetails
        title={active ? "Triggers Summary" : "Inactive Triggers"}
        titleSuffix={`${itemsLength || 0} template(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={updateAuth}
        filterAction={false}
        marginPass="15px"
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: `/ca-admin/organization/communications/triggers/add-trigger/${userInfo.data.organization.id}`,
        }}
        customContent={
          <Switch
            style={{
              backgroundColor: active ? "#50C878" : "#FF0000",
              minWidth: "90px",
            }}
            checked={active}
            // disabled={loading}
            // onChange={handleSwitchChange}
            checkedChildren="ACTIVE"
            unCheckedChildren="INACTIVE"
          />
        }
      />

      <Spin spinning={loading}>
        <Table
          dataSource={data}
          columns={columns}
          size="small"
          rowKey="id"
          bordered
          className="table-container"
          pagination={false}
          style={{ margin: "1rem" }}
          scroll={{
            y: `${remainingViewportHeight(36)}px`,
            x: 1000,
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            // onShowSizeChange={onShowSizeChange}
            // onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            // total={itemsLength}
          />
        </div>
      </Spin>
    </CaSideNav>
  );
};

export default Triggers;
